/** Padrão visual para inputs com máscara de data/hora (rótulos em maiúsculas) */
export const MASK_PLACEHOLDER_DATE = 'DD/MM/AAAA';
export const MASK_PLACEHOLDER_TIME = 'HH:MM';
/** Data e hora no mesmo campo (legado); preferir campos separados com DATA + HORA */
export const MASK_PLACEHOLDER_DATETIME = 'DD/MM/AAAA HH:MM';
